import React, { useEffect } from 'react';
import { FaCheckCircle, FaInfoCircle, FaExclamationCircle, FaTimes } from 'react-icons/fa';

const toastTypes = {
  success: {
    icon: FaCheckCircle,
    bgColor: 'bg-green-500',
    borderColor: 'border-green-600'
  },
  info: {
    icon: FaInfoCircle,
    bgColor: 'bg-blue-500',
    borderColor: 'border-blue-600'
  },
  error: {
    icon: FaExclamationCircle,
    bgColor: 'bg-red-500',
    borderColor: 'border-red-600'
  }
};

const Toast = ({ message, type = 'info', onClose, duration = 3000 }) => {
  useEffect(() => {
    if (duration) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const { icon: Icon, bgColor, borderColor } = toastTypes[type];

  return (
    <div className="fixed top-4 right-4 z-50 animate-fadeIn">
      <div className={`${bgColor} border-l-4 ${borderColor} rounded-lg shadow-lg p-4 flex items-center space-x-3 text-white min-w-[300px]`}>
        <Icon className="w-5 h-5 flex-shrink-0" />
        <p className="flex-1">{message}</p>
        <button
          onClick={onClose}
          className="p-1 hover:bg-white/20 rounded-full transition-colors"
        >
          <FaTimes className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default Toast; 